import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { accessToken, cacChubSSNId } from '../state/local-cache';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Add Authorization header
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken()}`,
      },
    });

    return next.handle(authReq).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const accessTokenRef = event.headers.get('access-token');
          if (accessTokenRef) {
            accessToken(accessTokenRef);
          }
          const chubSSNid = event.headers.get('cac-chub-ssid');
          if (chubSSNid) {
            cacChubSSNId(chubSSNid);
          }
        }
      })
    );
  }
}
